module.exports = __webpack_public_path__ + "static/media/tire-pressure-warning.4ca0dd90.svg";